export default {
    //品牌馆主题特色
    BrandTheme:[
        {id:'1',name:'团建拓展'},
        {id:'2',name:'研学旅行'},
        {id:'3',name:'亲子度假'},
        {id:'4',name:'会议展览'}
    ],
    EateryType:[
        {id: '1',name:'桌'},
        {id: '2',name:'人'}
    ],
    EateryTime:[
        {id: '1',name:'早餐'},
        {id: '2',name:'中餐'},
        {id: '3',name:'晚餐'},
    ],
    BMealType:[
        {id:'1',name:'中餐'},
        {id:'2',name:'西餐'},
        {id:'3',name:'料理'},
        {id:'4',name:'自助餐'},
        {id:'5',name:'烧烤'},
        {id:'6',name:'糕点'},
        {id:'7',name:'风味小吃'},
        {id:'8',name:'茶水冷饮'},
        {id:'99',name:'其他'},
    ],
    // 品牌馆订单
    BOrderStatus: [
        {id: 14, name: '待确认'},
        {id: 7, name: '待收订金'},
        {id: 8, name: '待收尾款'},
        {id: 9, name: '订单完成'},
        {id: 99, name: '超时取消'},
        { id: 100, name: '已取消' },
    ],
    // 采购商管理员看品牌馆订单状态
    TBOrderStatus: [
        { id: 14, name: '等待品牌馆确认' },
        { id: 7, name: '待付订金' },
        { id: 8, name: '待付尾款' },
        { id: 9, name: '订单完成' },
        { id: 99, name: '超时取消' },
        { id: 100, name: '已取消' },
    ],
    /*会议室时间节点*/
    BTimeSlots: [
        { id: 1, name: '上午' },
        { id: 2, name: '下午' },
        { id: 3, name: '晚上' },
        { id: 4, name: '上下午' },
    ],
    // 会议室价格
    BPTimeSlots: [
        { id: 'fc_price_1', name: '上午' },
        { id: 'fc_price_2', name: '下午' },
        { id: 'fc_price_3', name: '晚上' },
        { id: 'fc_price_4', name: '上下午' },
    ],
    // 支付人
    PayerPeople: [
        { id: '100', name: '预订人' },
        { id: '1', name: '领队' },
        { id: '2', name: '导游' },
    ],
}
